import React, { useEffect, useMemo, useState } from 'react';
import { Guide } from '@/pages/home/components/Guide';
import {
  getLocale,
  useDispatch,
  useIntl,
  useLocation,
  useSelector,
  history,
} from 'umi';
import download_settings_mobile_cn from './imgs/cn/download_settings_mobile_cn@2x.png';
import download_settings_mobile_en from './imgs/en/download_settings_mobile_en@2x.png';
import download_settings_pc_console_cn from './imgs/cn/download_settings_pc&console_cn@2x.png';
import download_settings_pc_console_en from './imgs/en/download_settings_pc&console_en@2x.png';

import {
  OPINION_GUIDE_BOX_LIST1,
  OPINION_GUIDE_HIDE,
} from '@/pages/home/components/GuideModule/GuideOpinionBox';
import {
  GUIDE_TYPE_OPINION_OVERVIEW,
  GUIDE_SYS_OPINION,
} from '@/pages/home/models/guide';
import { storage } from '@/utils/utils';

const STEP1_PATH = '/opinion/Overview/KeyMetrics';
const STEP2_PATH = '/opinion/Overview/KeyOpinions';
const STEP3_PATH = '/opinion/Summary/HotEvent';
const STEP_PATH_LIST = [
  STEP1_PATH,
  STEP1_PATH,
  STEP2_PATH,
  STEP2_PATH,
  STEP3_PATH,
  STEP3_PATH,
];

import './index.scss';
import { blackChildren } from '../LeftMenu';
import { useGetSingePageSourceRule } from '@op/hooks/useGetPageSourceRule';
import useOpinionGuideData from '@home/components/GuideModule/GuideOpinionBox/useOpinionGuideData';

const GuideOverView = () => {
  const location = useLocation();
  const { pathname, query } = location;
  const { from } = query || {};
  const [currentGuideStep, setCurrentGuideStep] = useState(-3);
  const { formatMessage } = useIntl();
  const locale = getLocale();
  const isEn = locale === 'en-US';
  const dispatch = useDispatch();
  const { guideType, userInfo, gameInfo } = useSelector((state: any) => {
    const {
      guide: { guideType },
      home: { userInfo },
      opinionCommon: { gameInfo },
    } = state;
    return {
      guideType,
      userInfo,
      gameInfo,
    };
  });
  const { excludeGuideSource } = useGetSingePageSourceRule({});
  const { GuideData } = useOpinionGuideData({
    gameInfo,
    userInfo,
    guidePermissions: excludeGuideSource,
  });

  const guideUsersHide = storage.getLocalStorageItem(OPINION_GUIDE_HIDE);

  // 注意下面两个useEffect不要合并到一起，不然会出现：从头部导航进入新手引导，点击到下一步时，关闭按钮无法关闭，而是返回到第一步
  useEffect(() => {
    if (guideType === GUIDE_TYPE_OPINION_OVERVIEW) {
      if (pathname !== STEP1_PATH && from !== 'userGuid_2') {
        return;
      }
      setCurrentGuideStep(
        from === 'userGuid_2' ? 2 : from === 'userGuid_4' ? 4 : 0,
      );
    }
  }, [guideType]);

  useEffect(() => {
    const list = storage.getLocalStorageItem(OPINION_GUIDE_BOX_LIST1) || [];
    const guideHide = storage.getLocalStorageItem(OPINION_GUIDE_HIDE);
    if (userInfo?.openid && !list.includes(userInfo.openid) && !guideHide) {
      if (pathname !== STEP1_PATH && from !== 'userGuid_4') {
        return;
      }
      setCurrentGuideStep(
        from === 'userGuid_4' ? 4 : from === 'userGuid_3' ? 3 : 0,
      );
    }
  }, [userInfo]);

  const onFinished = () => {
    if (userInfo.openid) {
      const list = storage.getLocalStorageItem(OPINION_GUIDE_BOX_LIST1) || [];
      !list?.includes(userInfo.openid) && list.push(userInfo.openid);
      storage.setLocalStorageItem(OPINION_GUIDE_BOX_LIST1, list);
    }
    dispatch({
      type: 'guide/showOpinionGuideModule',
      payload: true,
    });
  };

  const onCloseStep = () => {
    dispatch({
      type: 'guide/save',
      payload: {
        guideSys: GUIDE_SYS_OPINION,
        guideType: '',
      },
    });
  };

  const onStepChange = (current: number) => {
    const { pathname } = location;
    if (current >= 0 && pathname !== STEP_PATH_LIST[current]) {
      history.push(`${STEP_PATH_LIST[current]}?from=userGuid_${current}`);
    }
    setCurrentGuideStep(current);
  };

  const subtitle = formatMessage({
    id: 'Overview of Opinions Data and Hot Topics',
  });
  const { blockList } = GuideData;
  const rank = blockList.findIndex((item) => item.tit === subtitle) + 1;
  const title = `${formatMessage({ id: 'Core Function' })} ${rank}`;

  const steps = useMemo(() => {
    let step1;
    if (gameInfo.entity_type === 'mobile') {
      step1 = {
        highlightElements: [
          // {
          //   element: () =>
          //     document.querySelectorAll('.mentions-sentiment-card')?.[0],
          //   padding: {
          //     paddingTop: 10,
          //     paddingBottom: 20,
          //     paddingLeft: 20,
          //     paddingRight: 20,
          //   },
          //   hasRadius: true,
          // },
          // {
          //   element: () =>
          //     document.querySelector(
          //       '.dbo-cardcontext-title-main.avg_sentiment',
          //     ),
          //   hasRadius: true,
          //   padding: {
          //     paddingTop: 10,
          //     paddingBottom: 10,
          //     paddingLeft: 10,
          //     paddingRight: 10,
          //   },
          // },
        ],
        scrollIntoViewOptions: {
          behavior: 'auto',
          block: 'end',
          inline: 'end',
        },
        element: () =>
          document.querySelectorAll('.mentions-sentiment-card')?.[0],
        title,
        subtitle,
        description: formatMessage({
          id: 'The Key Metrics page presents the performance of key metrics, the total mentions and sentiment of the opinions, and the comparison between the DAU and revenue trends.',
        }),
        placement: 'top',
        bubbleStyle: {
          maxWidth: isEn ? '565px' : '630px',
        },
        padding: {
          paddingTop: 5,
          paddingBottom: 5,
        },
      };
    } else {
      step1 = {
        highlightElements: [
          // {
          //   element: () =>
          //     document.querySelector(
          //       '.dbo-cardcontext-title-main.avg_sentiment',
          //     ),
          // },
        ],
        element: () =>
          document.querySelectorAll('.mentions-sentiment-card')?.[0],
        title, 
        scrollIntoViewOptions: {
          behavior: 'auto',
          block: 'end',
          inline: 'center',
        },
        subtitle,
        description: formatMessage({
          id: 'The Key Metrics page presents the performance of key metrics, the total mentions and sentiment of the opinions.',
        }),
        placement: 'top-start',
        bubbleStyle: {
          maxWidth: isEn ? '520px' : '630px',
        },
        padding: {
          paddingLeft: 20,
          paddingRight: 20,
          paddingTop: 5,
          paddingBottom: 5,
        },
      };
    }

    let downloadExtImage = isEn
      ? download_settings_mobile_en
      : download_settings_mobile_cn;

    if (gameInfo.entity_type !== 'mobile') {
      downloadExtImage = isEn
        ? download_settings_pc_console_en
        : download_settings_pc_console_cn;
    }

    const steps: any = [
      step1,
      {
        element: () => document.querySelector('.dbo-performance-download'),
        title,
        subtitle,
        description: formatMessage({
          id: 'Click to download all opinion metrics. You can check any metrics and split the metrics by the selected dimension.',
        }),
        placement: 'top-end',
        extImage: {
          image: downloadExtImage,
          placement: 'bottom',
          wrapperClassName: 'opinion-user-guide-overview-download-image',
          style: {
            width: isEn ? 800 : 500,
          },
        },
      },
      // {
      //   element: () =>
      //     document.querySelector('.performance-topic-keyword-card'),
      //   title,
      //   subtitle,
      //   description: formatMessage({
      //     id: 'View the mentions ratio by topic. Click on a single topic and view the keywords of the topic through the word cloud on the right.',
      //   }),
      //   placement: 'top',
      // },

      // {
      //   element: () => document.querySelector('.dbo-performance-keyword-card'),
      //   title,
      //   subtitle,
      //   description: formatMessage({
      //     id: 'Click on a keyword to access the details page for specific reviews.',
      //   }),
      //   placement: 'left',
      // },
    ];
    // !blackChildren.includes('Hot Event')
    if (false) {
      const hotEventGuide = [
        {
          highlightElements: [
            {
              element: document.querySelector('.menu-context-text-HotEvent'),
            },
            {
              element: document.querySelector('.dbo-hotcard-flex-other'),
            },
          ],
          element: () =>
            document.querySelectorAll('.dbo-hotcard-flex-table tr')?.[2] ||
            document.querySelectorAll('.dbo-hotcard-flex-table tr')?.[1],
          title,
          subtitle,
          description: formatMessage({
            id: 'The Summary page presents the clustered hot content based on the NLP algorithm. Click the events on the left to view the detailed reviews on the right.',
          }),
          placement: 'bottom',
          // padding: { paddingRight: 10 },
        },

        {
          element: () =>
            document.querySelectorAll('.dbo-hotcard-flex-table tr')?.[2] ||
            document.querySelectorAll('.dbo-hotcard-flex-table tr')?.[1],
          title,
          subtitle,
          description: formatMessage({
            id: 'Click a keyword to view the relevant reviews.',
          }),
          placement: 'bottom',
        },
      ];

      steps.push(...hotEventGuide);
    }
    return steps;
  }, [currentGuideStep, locale]);
  if (guideType !== GUIDE_TYPE_OPINION_OVERVIEW) return null;

  return (
    // finishText 根据中英文调整
    <Guide
      current={currentGuideStep}
      onCurrentChange={(
        current: number,
        context: {
          from: 'start' | 'back' | 'next' | 'finish' | 'cancel' | 'nodata';
        },
      ) => {
        const { from } = context;
        setCurrentGuideStep(current);
        onStepChange(current);
        if (from === 'finish' || from === 'nodata') {
          onFinished();
        } else if (from === 'cancel') {
          onCloseStep();
          onFinished();
        }
      }}
      visibleCloseBtn
      hideCancelButton
      showBackButton
      nextButtonTheme="primary"
      backText={formatMessage({ id: 'guide_last_step' })}
      nextText={formatMessage({ id: 'guide_next_step' })}
      finishText={formatMessage({ id: 'guide_more_step' })}
      steps={steps}
      showLoading={false}
    />
  );
};

export default () => {
  const location = useLocation();

  return <>{STEP_PATH_LIST.includes(location.pathname) && <GuideOverView />}</>;
};
